<!--
 * @Author: lsl
 * @Date: 2022-08-22 14:53:58
 * @Description: 
-->
<style scoped lang="scss">
.wrap-summary{
  margin-bottom: 80px;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .wrap-summary{
    margin-bottom: 20px!important;
  }
}

</style>
<template>
  <div class="wrap wrap-summary">
    <div class="banner">
      <img src="@/assets/img/jianjie.png" class="img-fluid">
      <qk-top-menu :menuLists="menuLists"/>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menuLists: [{name: '擎科简介', ref: '/summary/about'},
        // {name: '发展历程', ref: '/summary/develop'},
        // {name: '全国布局', ref: '/summary/global'},
        {name: '发展成果', ref: '/summary/achievement'},
        {name: '联系我们', ref: '/summary/contact'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/summary/index.vue